// extracted by mini-css-extract-plugin
export default {"highlighted":"NoteWrapper-module__highlighted___JaLDW","highlightNote":"NoteWrapper-module__highlightNote___cYjkz"};